/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changelog_Index_Meta_TitleInputs */

const id_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catatan Perubahan | egdata.app`)
};

const ms_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log Perubahan | egdata.app`)
};

const da_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændringslog | egdata.app`)
};

const de_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungsprotokoll | egdata.app`)
};

const en_us2_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changelog | egdata.app`)
};

const es_es2_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de cambios | egdata.app`)
};

const es_mx2_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de cambios | egdata.app`)
};

const fil_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talaan ng Pagbabago | egdata.app`)
};

const fr_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Journal des modifications | egdata.app`)
};

const it_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro modifiche | egdata.app`)
};

const hu_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Változásnapló | egdata.app`)
};

const nl_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijzigingslogboek | egdata.app`)
};

const no_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endringslogg | egdata.app`)
};

const pl_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dziennik zmian | egdata.app`)
};

const pt_br2_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de alterações | egdata.app`)
};

const pt_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registo de alterações | egdata.app`)
};

const ro_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jurnal modificări | egdata.app`)
};

const fi_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutosloki | egdata.app`)
};

const sv_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändringslogg | egdata.app`)
};

const vi_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhật ký thay đổi | egdata.app`)
};

const tr_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklik Günlüğü | egdata.app`)
};

const cs_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seznam změn | egdata.app`)
};

const bg_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дневник на промените | egdata.app`)
};

const ru_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журнал изменений | egdata.app`)
};

const uk_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журнал змін | egdata.app`)
};

const ar_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجل التغييرات | egdata.app`)
};

const hi_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बदलाव लॉग | egdata.app`)
};

const th_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บันทึกการเปลี่ยนแปลง | egdata.app`)
};

const ja_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新履歴 | egdata.app`)
};

const zh_cn2_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新日志 | egdata.app`)
};

const zh_hant1_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新日誌 | egdata.app`)
};

const ko_changelog_index_meta_title = /** @type {(inputs: Changelog_Index_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경 내역 | egdata.app`)
};

/**
* | output |
* | --- |
* | "Changelog \| egdata.app" |
*
* @param {Changelog_Index_Meta_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const changelog_index_meta_title = /** @type {((inputs?: Changelog_Index_Meta_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changelog_Index_Meta_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_changelog_index_meta_title(inputs)
	if (locale === "ms") return ms_changelog_index_meta_title(inputs)
	if (locale === "da") return da_changelog_index_meta_title(inputs)
	if (locale === "de") return de_changelog_index_meta_title(inputs)
	if (locale === "en-US") return en_us2_changelog_index_meta_title(inputs)
	if (locale === "es-ES") return es_es2_changelog_index_meta_title(inputs)
	if (locale === "es-MX") return es_mx2_changelog_index_meta_title(inputs)
	if (locale === "fil") return fil_changelog_index_meta_title(inputs)
	if (locale === "fr") return fr_changelog_index_meta_title(inputs)
	if (locale === "it") return it_changelog_index_meta_title(inputs)
	if (locale === "hu") return hu_changelog_index_meta_title(inputs)
	if (locale === "nl") return nl_changelog_index_meta_title(inputs)
	if (locale === "no") return no_changelog_index_meta_title(inputs)
	if (locale === "pl") return pl_changelog_index_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_changelog_index_meta_title(inputs)
	if (locale === "pt") return pt_changelog_index_meta_title(inputs)
	if (locale === "ro") return ro_changelog_index_meta_title(inputs)
	if (locale === "fi") return fi_changelog_index_meta_title(inputs)
	if (locale === "sv") return sv_changelog_index_meta_title(inputs)
	if (locale === "vi") return vi_changelog_index_meta_title(inputs)
	if (locale === "tr") return tr_changelog_index_meta_title(inputs)
	if (locale === "cs") return cs_changelog_index_meta_title(inputs)
	if (locale === "bg") return bg_changelog_index_meta_title(inputs)
	if (locale === "ru") return ru_changelog_index_meta_title(inputs)
	if (locale === "uk") return uk_changelog_index_meta_title(inputs)
	if (locale === "ar") return ar_changelog_index_meta_title(inputs)
	if (locale === "hi") return hi_changelog_index_meta_title(inputs)
	if (locale === "th") return th_changelog_index_meta_title(inputs)
	if (locale === "ja") return ja_changelog_index_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_changelog_index_meta_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_changelog_index_meta_title(inputs)
	return ko_changelog_index_meta_title(inputs)
});
export { changelog_index_meta_title as "changelog.index.meta.title" }